<template>
	<div
		v-if="showSiteNotification && !dismissed"
		class="w-full bg-orange-400 text-white font-bold pt-5 pb-3 px-2 md:px-4 fixed z-40 customSiteNotification">
		<div class="sm:container mx-auto md:max-w-screen-lg sm:px-4">
			<div
				class="text-center"
				v-html="siteNotificationMsg"></div>
			<div class="text-center">
				<FormLink
					:slim="true"
					custom-class="!text-white font-bold text-right pt-2"
					@click="dismissNotification"
					>{{ $t("dismiss") }}</FormLink
				>
			</div>
		</div>
	</div>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()
	const { $messages } = useNuxtApp()
	const showSiteNotification = runtimeConfig.public.SHOW_SITE_NOTIFICATION
	const siteNotificationMsg = $messages.$t("siteNotificationMsg")
	const siteNotificationCookie = "UP_DISMISSED_SITE_NOTIFICATION"

	let dismissed = ref(false)

	const cookie = useCookie(siteNotificationCookie, {
		maxAge: 60 * 60, // 1 hour
		path: "/", // Cookie available across the entire site
		secure: true, // Only sent over HTTPS
		httpOnly: false, // Accessible via JavaScript
		sameSite: "lax", // Prevent CSRF attacks
	})

	const dismissNotification = () => {
		dismissed.value = true
		cookie.value = siteNotificationCookie
	}

	// Check if the cookie exists
	if (cookie.value === siteNotificationCookie) {
		dismissed.value = true
	}
</script>

<style scoped></style>
